import React, { useState } from 'react';

/**
 * Modal reutilizável para seleção de Tipo de Bem.
 *
 * Props:
 *  - show             {boolean}   controla a visibilidade do modal
 *  - tiposBens        {Array}     lista de tipos de bens disponíveis
 *  - selectedTipoBem  {string|number} id do tipo de bem atualmente selecionado
 *  - onSelect         {Function}  chamada com o objeto tipoBem ao clicar em uma linha
 *  - onClose          {Function}  chamada ao fechar o modal
 */
function TipoBemPicker({ show, tiposBens = [], selectedTipoBem, onSelect, onClose }) {
  const [search, setSearch] = useState('');

  if (!show) return null;

  const filtered = tiposBens
    .filter(t =>
      t.descricao.toUpperCase().includes(search.toUpperCase())
    )
    .sort((a, b) => a.descricao.localeCompare(b.descricao, 'pt-BR'));

  function handleSelect(t) {
    onSelect(t);
    setSearch('');
  }

  function handleClose() {
    setSearch('');
    onClose();
  }

  return (
    <div
      style={{
        position: 'fixed',
        inset: 0,
        backgroundColor: 'rgba(0,0,0,0.6)',
        zIndex: 1065,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <div
        className="modal-content"
        style={{
          width: '90%',
          maxWidth: 520,
          height: 500,
          minHeight: 500,
          maxHeight: 500,
          display: 'flex',
          flexDirection: 'column',
          borderRadius: 6,
          overflow: 'hidden',
        }}
      >
        {/* Header */}
        <div className="modal-header bg-primary text-white" style={{ padding: '0.35rem 1rem' }}>
          <h6 className="modal-title mb-0 small">
            <i className="bi bi-box-seam me-2"></i>SELECIONAR TIPO DE BEM
          </h6>
          <button type="button" className="btn-close btn-close-white" onClick={handleClose} />
        </div>

        {/* Body */}
        <div className="modal-body" style={{ display: 'flex', flexDirection: 'column', overflow: 'hidden', padding: '1rem' }}>
          {/* Campo de busca */}
          <div className="mb-3">
            <label className="form-label small fw-semibold text-muted">
              <i className="bi bi-search me-1"></i>BUSCAR
            </label>
            <input
              autoFocus
              type="text"
              className="form-control form-control-sm text-uppercase"
              placeholder="Buscar por descrição"
              value={search}
              onChange={e => setSearch(e.target.value.toUpperCase())}
              style={{ textTransform: 'uppercase' }}
            />
          </div>

          {/* Tabela de resultados */}
          <div className="border rounded" style={{ overflowY: 'auto', flex: 1 }}>
            <table className="table table-hover table-sm mb-0">
              <thead className="table-light">
                <tr>
                  <th className="small">Descrição</th>
                </tr>
              </thead>
              <tbody>
                {filtered.map(t => (
                  <tr
                    key={t.id}
                    style={{ cursor: 'pointer' }}
                    onClick={() => handleSelect(t)}
                    className={selectedTipoBem === t.id ? 'table-success' : ''}
                  >
                    <td className="small">{t.descricao}</td>
                  </tr>
                ))}
                {filtered.length === 0 && (
                  <tr>
                    <td className="text-center text-muted small py-3">
                      <i className="bi bi-inbox me-2"></i>Nenhum tipo de bem encontrado.
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>

        {/* Footer */}
        <div className="modal-footer" style={{ padding: '0.4rem 1rem' }}>
          <button type="button" className="btn btn-secondary btn-sm" onClick={handleClose}>Fechar</button>
        </div>
      </div>
    </div>
  );
}

export default TipoBemPicker;
